import { render, staticRenderFns } from "./originality.vue?vue&type=template&id=41187c86&"
import script from "./originality.vue?vue&type=script&lang=js&"
export * from "./originality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports